const UsbCmd = {
    reset: "cmd_00",
    runScript: "cmd_01",
    stopScript: "cmd_02",
    getVmVer: "cmd_03",
    getBrainVer: "cmd_04",
    scriptErase: "cmd_05",
    scriptWrite: "cmd_06",
    getScriptRunningStatus: "cmd_07",
    getBrainInfo: "cmd_08",

    // Not reality
    restoreBrain: "cmd_09",

    getSlotInfo: "cmd_11",
    enterLoader: "cmd_12",
    getBatteryInfo: "cmd_13",
    resetToDefault: "cmd_15",
    getBtFirmwareVer: "cmd_17",
    deviceError: "device_error",

    pushFw: "pushfw",
    distributeFw: "distributefw",
    getBackupFw: "getbackupfw",
    updateSystem: "updatesystem",
    updateState: "updatestate",

    getPortState: "getportstate",
    writeScript: "writeScript",
    getControllerVer: "rccmd_ver",
    error: "error",
    getBrainType: "getbraintype",
    wScp: "w sys",
    xReset: "x reset"
};


const UsbResponse = {
    START: 'start',
    SUCCESS: 'success',
    IDLE: 'idle',
    UPDATING: 'updating'
}

const DeviceStateCmd = {
    VM: "vm",
    LOADER: "loader"
}

const DeviceErrorCmd = {
    BRAIN_SYSTEM_VM_NOT_MATCH: 0,
}

const DfuCmd = {
    UPDATE_BT: "updateBT",
    UPDATE_RC: "updateRC"
}


const DfuResponse = {
    ERROR_NO_PARAM_UART_PORT: '001',
    ERROR_NO_UPDATE_FILE: '002',
    ERROR_NO_HASH_FILES: '003',
    ERROR_CONNECT_FAILED: '004',
    ERROR_FILE_NOT_COMPATIBLE: '005',
    ERROR_MODULE_DISCONNECT: '006',

    ACTION_NONE_VERSION_THE_SAME: '101',
    ACTION_START_UPLOAD_IMAGE: '102',
    ACTION_START_UPDATING: '103',

    PROGRESS_UPLOAD_END: '201',
    PROGRESS_DFU_END: '202',

    UPDATE_FINISH: '1001',
    UPDATE_FAILED: '1021'
}

const EraseScriptCmd = {
    START: 2003,
    END: 2013,
}

const WriteScriptCmd = {
    START: 2002,
    END: 2012,

}

const WriteBinCmd = {
    START: 2001,
    END: 2011,
    DISCONNECT: 2022,
}

const WriteSystemCmd = {
    START: 2004,
    END: 2014,
}

const ErrorScriptCmd = {
    CANCEL: 2021
}

const BrainType = {
    ENTRY: 1,
    PRO: 1,
    ENTRY_AND_EDU: 1,
    EDU: 2,
    ENTRY_SOCKET: 3
}

const BrainRunningStatus = {
    IDLE: 0,
    RUNNING: 1,
    RFID_MODE: 2,
    BLUETOOTH_MODE: 3, //BT script running
    DOWNLOAD_SCRIPT: 4,
    BLUETOOTH_DOWNLOAD_PHONE_SCRIPT: 5, //BT script download (phone)
    BLUETOOTH_DOWNLOAD_BLOCKLY_SCRIPT: 6 //BT script download (ipad)
}

const DeviceType = {
    EDU_HULK: "EDU",
    ENTRY_HULK: "ENTRY",
    EDU_AND_ENTRY_HULK: "EDU_AND_ENTRY",
    RC_LOADER: "RC_LOADER",
    RC: "RC",
    BT: "BT",
    ENTRY_SOCKET: "ENTRY_SOCKET",
    RB101: "RB101"
}


const WifiStatus = {
    DISABLED: "DISABLED",
    NO_SETTING: "NO_SETTING",
    SCANNING: "SCANNING",
    CONNECTING: "CONNECTING",
    COMPLETED: "COMPLETED",
    AUTH_FAIL: "AUTH_FAIL",
    LINK_FAIL: "LINK_FAIL"
}

export {
    UsbCmd,
    EraseScriptCmd,
    WriteScriptCmd,
    WriteBinCmd,
    WriteSystemCmd,
    ErrorScriptCmd,
    BrainType,
    BrainRunningStatus,
    DeviceType,
    DeviceStateCmd,
    DeviceErrorCmd,
    UsbResponse,
    DfuCmd,
    DfuResponse,
    WifiStatus,
};
